import { Icon, IconProps } from "@/base/components/icon/Icon.component";
import IconSvg from "./loading-extra-large.svg?react";

export const LoadingExtraLargeIcon = (props: IconProps) => (
  <Icon component={IconSvg} {...props} />
);
